export default {
  handler: 'relativeUrl',
  data: () => '/quick_deposit',
};
